import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Variable-Fonts selbst gehostet (woff2). Keine Google-CDN-Abhaengigkeit,
// kein FOIT — Inter fuer UI, JetBrains Mono fuer Zahlen/IDs.
import "@fontsource-variable/inter";
import "@fontsource-variable/jetbrains-mono";

import "./index.css";
import { installChunkErrorListener } from "./lib/chunkReload";
import { initSentry } from "./lib/sentry";
import { initTheme } from "./lib/theme";
import { App } from "./App";

initSentry();
initTheme();
// POL-1: fensterweite Erholung nach Deploy fuer lazy-Ladefehler ausserhalb
// des React-Render-Pfads (import() in Handlern + Vites vite:preloadError).
installChunkErrorListener();

const container = document.getElementById("root");
if (!container) throw new Error("Root container #root not found");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
